import React from "react";
import {
  FaPalette,
  FaFileContract,
  FaStore,
  FaCheckCircle,
  FaWallet,
  FaProjectDiagram,
} from "react-icons/fa";

function CustomNFTDesigns() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Unleash new spectrum within your real-world asset ecosystem
                  with our NFT development services
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  We empower businesses and individuals to tokenize tangible
                  assets—such as real estate, art, luxury goods, and more—into
                  secure, tradable NFTs.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaPalette size={40} />
                  </div>
                  <h4>Custom NFT Designs</h4>
                  <p>
                    Create unique and secure NFTs tailored to your project,
                    whether it’s for art, gaming, real estate, or other sectors.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaFileContract size={40} />
                  </div>
                  <h4>NFT Contract Development</h4>
                  <p>
                    We build robust, secure, and tamper-proof smart contracts to
                    power your NFTs on blockchain platforms like Ethereum,
                    Binance Smart Chain, Solana, and more.
                  </p>
                  <br />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaStore size={40} />
                  </div>
                  <h4>Marketplace Integration</h4>
                  <p>
                    Seamless integration with popular NFT marketplaces, enabling
                    you to list, trade, and auction your NFTs globally.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaCheckCircle size={40} />
                  </div>
                  <h4>Token Standards Compliance</h4>
                  <p>
                    Support for leading token standards such as ERC-721,
                    ERC-1155, and others, ensuring interoperability and
                    scalability.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaWallet size={40} />
                  </div>
                  <h4>NFT Wallet Development</h4>
                  <p>
                    We also offer NFT Wallet Development to help your users
                    securely store, manage, and trade NFTs with ease.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon">
                    <FaProjectDiagram size={40} />
                  </div>
                  <h4>Cross-Chain NFT Solutions</h4>
                  <p>
                    Enhance the reach of your NFTs with cross-chain
                    compatibility, allowing users to trade NFTs across multiple
                    blockchains.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomNFTDesigns;
